import * as types from "./mutation_types"
export default {
    [types.RESET](state) {
        Object.assign(state, {
            isLoading: false,
            showMessage: false,
            isSuccess: false,
            message: "",
            permissions: [],
            isLogin: false,
            item: null,
        })
    },

    [types.SET_SHOW_LOADING](state) {
        Object.assign(state, { isLoading: true })
    },
    [types.SET_HIDE_LOADING](state) {
        Object.assign(state, { isLoading: false })
    },
    [types.SET_IS_LOGIN](state, isLogin) {
        Object.assign(state, { isLogin })
    },

    [types.SET_SHOW_MESSAGE](state) {
        Object.assign(state, { showMessage: true })
    },
    [types.SET_HIDE_MESSAGE](state) {
        Object.assign(state, { showMessage: false })
    },

    [types.SET_IS_SUCCESS](state) {
        Object.assign(state, { isSuccess: true })
    },
    [types.SET_IS_ERROR](state) {
        Object.assign(state, { isSuccess: false })
    },
    [types.SET_MESSAGE](state, message) {
        Object.assign(state, { message })
    },
    [types.SET_ITEMS](state, item) {
        Object.assign(state, { item })
    },
    [types.SET_PERMISSIONS](state, permissions) {
        Object.assign(state, { permissions })
    },


}